import WineHero from 'assets/images/psp/hero/wine-hero.webp';
import wineFeatured1 from 'assets/images/psp/FeaturedImages/wine-1.webp';
import wineFeatured2 from 'assets/images/psp/FeaturedImages/wine-2.webp';
import wineFeatured3 from 'assets/images/psp/FeaturedImages/wine-3.webp';

const faqs = [
	{
		question: 'Can you store alcohol in a storage unit?',
		answer:
			'Most storage facilities allow alcohol storage, but policies vary by location and local regulations. We recommend checking with your specific facility before storing wine or spirits. Some areas have restrictions on alcohol storage due to local laws or insurance requirements. \n\n' +
			'When storing alcohol in a storage unit, temperature control is crucial. Standard units without climate control can experience extreme temperature fluctuations that damage wine, causing corks to expand and contract, potentially leading to oxidation or spoilage. Climate-controlled units maintain steady temperatures between 55-75°F, making them ideal for wine storage. \n\n' +
			"Security is another important consideration. Alcohol can be valuable and attractive to thieves, so choose a facility with robust security features like surveillance cameras, gated access, and good lighting. Consider using a unit that's not on the ground floor for added security. \n\n" +
			"Insurance coverage varies for stored alcohol. Some facilities' standard coverage may exclude alcoholic beverages, while others include them up to a certain value. For valuable wine collections, additional insurance may be necessary. \n\n" +
			'Proper packaging is essential. Use wine shipping boxes with foam inserts or wooden wine crates for added protection. Avoid storing bottles directly on concrete floors, which can transfer vibrations and temperature fluctuations. Instead, use shelving or pallets to elevate your collection. \n\n' +
			"Before committing to long-term storage, verify that your chosen facility's policies align with your storage needs and local regulations regarding alcohol storage.",
	},
	{
		question: 'Can you tell me how to store wine without a wine cellar?',
		answer:
			'Storing wine without a traditional cellar is possible with the right approach and environment. Many wine enthusiasts successfully age bottles using alternative storage methods that maintain optimal conditions. \n\n' +
			"The key factors are temperature, humidity, light, and vibration control. Ideal storage maintains around 55-65°F with 50-80% humidity. Basements often provide these conditions naturally, making them excellent wine storage locations. If you don't have a basement, consider interior closets, under-stair spaces, or unused rooms that stay consistently cool. \n\n" +
			'Climate-controlled storage units offer professional-grade wine storage conditions. These units maintain steady temperatures and humidity levels year-round, protecting your investment from seasonal fluctuations. This option is particularly valuable for apartment dwellers or those in climates with extreme temperature variations. \n\n' +
			"Wine refrigerators provide controlled environments for smaller collections. Unlike regular refrigerators, wine fridges maintain proper humidity and temperature without excessive vibration. They're available in various sizes, from countertop models to large cabinet-style units. \n\n" +
			'Avoid common storage mistakes like keeping wine in kitchens, garages, or areas near heating systems where temperatures fluctuate dramatically. Protect bottles from direct sunlight and fluorescent lighting, which can cause premature aging and off-flavors. \n\n' +
			'For horizontal storage, use wine racks that keep corks moist and prevent oxidation. If storing bottles upright temporarily, consume them within a few months. Maintain consistent positioning to avoid disturbing sediment in older wines. \n\n' +
			'Regular monitoring with a thermometer and hygrometer helps ensure conditions remain stable for optimal wine preservation.',
	},
	{
		question: 'How do I store wine for 20 years?',
		answer:
			'Long-term wine storage requires meticulous attention to environmental conditions and proper storage techniques. Twenty-year aging demands consistency above all else, as even minor fluctuations can compromise wine quality over such extended periods.\n\n' +
			'Temperature stability is critical. Maintain 55-60°F consistently, as this range slows aging appropriately while preventing spoilage. Temperature fluctuations cause wine to expand and contract, potentially pushing corks out slightly and allowing oxidation. Even quality wine refrigerators may not provide the ultra-stable conditions needed for decades-long storage.\n\n' +
			'Climate-controlled storage units often provide the most reliable long-term environment. Professional facilities maintain precise temperature and humidity control with backup systems to prevent equipment failures. This redundancy is crucial for protecting valuable wines over two decades.\n\n' +
			'Humidity should remain between 60-70% to keep corks from drying out while preventing mold growth. Too low humidity causes cork shrinkage and oxidation; too high promotes mold and label damage.\n\n' +
			'Store bottles horizontally to keep corks moist, but minimize handling and movement. Vibration disturbs sediment and can accelerate chemical reactions that alter flavor profiles. Choose storage locations away from appliances, traffic, or construction.\n\n' +
			'Document your collection meticulously. Track purchase dates, storage conditions, and tasting notes. This information becomes invaluable for determining optimal drinking windows.\n\n' +
			"Invest in insurance coverage specifically for wine collections. Standard homeowner's policies often exclude or limit alcohol coverage. Professional wine storage insurance protects against temperature failures, natural disasters, and theft.\n\n" +
			'Consider professional wine storage services for truly valuable collections, as they provide optimal conditions with expert monitoring and security.',
	},
	{
		question: 'Does bottle position matter when storing wine?',
		answer:
			"Bottle position significantly impacts wine preservation, especially for long-term storage. The traditional horizontal storage method isn't just aesthetic—it's scientifically based on cork maintenance and wine chemistry.\n\n" +
			'Horizontal storage keeps natural corks in contact with wine, preventing them from drying out and shrinking. Dried corks allow air to enter the bottle, causing oxidation that turns wine into vinegar-like liquid. This is particularly crucial for wines stored longer than six months.\n\n' +
			'However, storage position depends on closure type. Wines with synthetic corks or screw caps can be stored upright without cork-related issues, though horizontal storage still offers advantages for organization and space efficiency in storage units.\n\n' +
			"For natural cork wines, the slight downward angle (neck slightly lower than bottom) is ideal. This position keeps corks moist while allowing any sediment to settle at the bottle's bottom, away from the neck area where it might be disturbed during opening.\n\n" +
			'Avoid storing bottles at steep angles or upside down, as this can drive corks deeper into bottles or cause excessive pressure on closures. Consistent positioning throughout storage prevents sediment disturbance in older wines.\n\n' +
			'Storage racks should hold bottles securely without pressure points that could cause vibration or stress. Wine storage units benefit from sturdy, vibration-dampening racks that maintain proper positioning even with facility access activity.\n\n' +
			'Temperature fluctuations affect cork expansion and contraction regardless of position, making climate-controlled storage essential for maintaining proper cork seal integrity over time.\n\n' +
			"For short-term storage (under three months), upright storage won't significantly harm most wines, but horizontal remains the preferred method for consistency and space optimization.",
	},
	{
		question: "What's the best temperature for red wine storage?",
		answer:
			'The optimal temperature for red wine storage is 55-65°F, with 60°F being ideal for most varieties. This temperature range slows the aging process appropriately, allowing complex flavors to develop gradually while preventing premature deterioration.\n\n' +
			'Temperature consistency matters more than hitting an exact number. Fluctuations cause wine to expand and contract repeatedly, potentially compromising cork seals and accelerating oxidation. Even high-quality wines can suffer irreparable damage from temperature swings, regardless of the average temperature.\n\n' +
			'Many people mistakenly store red wine at room temperature long-term, but modern homes often exceed 70°F, which accelerates aging too rapidly. While red wines are served at 60-68°F, storage temperatures should be cooler to preserve quality over months or years.\n\n' +
			'Climate-controlled storage units provide ideal conditions for red wine collections. These units maintain steady temperatures regardless of external weather conditions, protecting wines from seasonal temperature variations that can reach extreme levels in non-climate-controlled spaces.\n\n' +
			'Different red wine styles have slight temperature preferences within the optimal range. Full-bodied wines like Cabernet Sauvignon and Syrah store well at the cooler end (55-58°F), while lighter reds like Pinot Noir can handle slightly warmer storage (58-65°F).\n\n' +
			'Avoid areas like garages, attics, or areas near heating systems where temperatures fluctuate dramatically. Even basements can experience seasonal temperature swings that compromise wine quality.\n\n' +
			'Professional wine storage facilities often maintain temperatures between 55-57°F with minimal fluctuation, representing the gold standard for serious collectors. This precision ensures optimal aging conditions for valuable red wine collections requiring long-term storage.',
	},
];

export const WineContent = {
	type: 'Wine',
	sections: [
		{
			title: 'Wine Storage Hero',
			background: 'yellow',
			modules: [
				{
					type: 'hero',
					id: 'wine-storage-hero',
					background: 'lighterYellow',
					props: {
						content: {
							title: 'Find the Best Wine Storage For You',
							description:
								'Your wine collection tells a story. Every bottle is a celebration or memory in the making. You want that story to be one full of joy and laughter, not a horror story full of bitterness and spoilage. Enter wine storage: the perfect solution to keeping your wine protected from oxidation, bacterial growth, or worse—cork taint. SpareFoot connects wine enthusiasts like you with temperature-controlled wine storage units that control humidity and light exposure, while maintaining a cool 55-65°F environment, the perfect temperature for red wine storage.',
							image: WineHero,
							CTAText: 'Search Wine Lockers & More',
						},
					},
				},
			],
		},
		{
			title: 'nearby storage',
			background: 'gray',
			noPaddingBottom: true,
			modules: [
				{
					type: 'facilitiesNearYou',
					props: {
						title: 'Popular Wine Storage Facilities Near',
					},
				},
			],
		},
		{
			title: 'Content section - single column',
			background: 'dark',
			modules: [
				{
					type: 'videoSection',
					props: {
						slug: 'Why wine storage matters',
						theme: 'dark',
						content: {
							title: 'Why is Proper Wine Storage Important?',
							description:
								"Proper wine storage is essential for preserving and enhancing your wine collection's quality, flavor, and long-term value. Without the right conditions, even expensive wines can become undrinkable or lose significant worth over time.",
						},
						src: 'https://www.youtube.com/embed/ooP62yZwg0I?si=c15_P57YDIeDleN7',
					},
				},
			],
		},
		{
			title: ' Wine Storage Temperature Guide',
			modules: [
				{
					type: 'content',
					props: {
						contentType: 'row-type',
						ShowBackgroundImage: false,
						title: 'Key reasons why proper wine storage matters:',
						content: [
							'- **Temperature control prevents flavor damage -** Wine stored outside the ideal temperature range can develop unpleasant cooked flavors or fail to age properly, while consistent cool temperatures allow wines to develop their intended complexity and character over time. Use our wine storage temperature chart to figure out the optimal storage temperature for your favorite pour.\n\n' +
								'**Wine Storage Temperature Guide**',
						],
					},
				},
				{
					type: 'sizeChart',
					props: {
						slug: 'wine-storage-temperature-guide',
						headers: [
							{
								label: 'Wine Type',
								key: 'Wine Type',
							},
							{
								label: 'Storage Temperature',
								key: 'Storage Temperature',
							},
						],
						rows: [
							{
								'Wine Type': 'Light White Wine',
								'Storage Temperature': '45-55°F',
							},
							{
								'Wine Type': 'Full-Bodied White Wine',
								'Storage Temperature': '45-55°F',
							},
							{
								'Wine Type': 'Sparkling Wine',
								'Storage Temperature': '40-50°F',
							},
							{
								'Wine Type': 'Rosé Wines',
								'Storage Temperature': '55-58°F',
							},
							{
								'Wine Type': 'Light Red Wine',
								'Storage Temperature': '55-58°F',
							},
							{
								'Wine Type': 'Medium Red Wine',
								'Storage Temperature': '55-58°F',
							},
							{
								'Wine Type': 'Full Bodied Red Wine',
								'Storage Temperature': '60-65°F',
							},
						],
					},
				},
				{
					type: 'content',
					props: {
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							"- **Light protection preserves wine integrity** - Exposure to light, especially UV rays, can degrade and prematurely age your wine, causing off-flavors and reducing the wine's potential for proper aging and appreciation. \n\n" +
								'- **Humidity balance protects cork integrity** - Maintaining proper humidity levels between 50-70% prevents corks from drying out and shrinking, which could allow air to seep in and spoil the wine. This also prevents mold growth that can damage labels and disrupt aging processes.\n\n' +
								'- **Vibration-free environment supports proper aging** - Constant movement and vibrations can disturb sediment and interfere with the delicate chemical processes that allow fine wines to develop their full potential.\n\n' +
								'- **Investment protection maintains value** - Professional storage conditions ensure your wine collection retains its market value and appreciation potential, protecting both casual bottles and rare vintages from costly deterioration.\n\n',
						],
					},
				},
				{
					type: 'content',
					props: {
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							"Whether you're collecting fine vintages or simply want to enjoy everyday wines at their peak quality, proper storage is the foundation of any successful wine collection.",
						],
					},
				},
			],
		},
		{
			title: 'Temperature-Controlled Wine Storage Size & Pricing Guide',
			background: 'gray',
			modules: [
				{
					type: 'content',
					props: {
						title: 'Temperature-Controlled Wine Storage Size & Pricing Guide',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							'For proper wine storage, a standard climate-controlled storage unit might not do the trick. \n\n' +
								'Wine storage requires a temperature and humidity range that differs slightly from your everyday climate-controlled storage unit. And as you know, when it comes to wine, a little goes a long way. \n\n' +
								'The best way to ensure your wine storage solution maintains the correct temperature and humidity levels is to rent a wine storage unit intended to store vino and only vino. \n\n',
						],
					},
				},
				{
					type: 'sizeChart',
					props: {
						slug: 'wine-storage-size-pricing-guide',
						// title: "Wine Storage Size Options",
						headers: [
							{
								label: 'Wine Storage Size Options',
								key: 'Wine Storage Size Options',
							},
							{
								label: 'Bottle Capacity',
								key: 'Bottle Capacity',
							},
							{
								label: 'Best For',
								key: 'Best For',
							},
							{
								label: 'Average Monthly Rate',
								key: 'Average Monthly Rate',
							},
						],
						rows: [
							{
								'Wine Storage Size Options': 'Personal Locker',
								'Bottle Capacity': '24-48 bottles (2-4 cases)',
								'Best For':
									'Casual collectors, special occasions',
								'Average Monthly Rate': '$25-45',
							},
							{
								'Wine Storage Size Options': 'Standard Locker',
								'Bottle Capacity': '60-96 bottles (5-8 cases)',
								'Best For': 'Growing collections, enthusiasts',
								'Average Monthly Rate': '$45-75',
							},
							{
								'Wine Storage Size Options': 'Premium Locker',
								'Bottle Capacity':
									'120-180 bottles (10-15 cases)',
								'Best For':
									'Serious collectors, investment wines',
								'Average Monthly Rate': '$75-120',
							},
							{
								'Wine Storage Size Options': 'Large Vault',
								'Bottle Capacity':
									'200-300 bottles (17-25 cases)',
								'Best For':
									'Extensive collections, restaurants',
								'Average Monthly Rate': '$120-200',
							},
							{
								'Wine Storage Size Options': 'Commercial Vault',
								'Bottle Capacity': '350+ bottles (30+ cases)',
								'Best For': 'Commercial storage, large estates',
								'Average Monthly Rate': '$200-350',
							},
						],
					},
				},
			],
		},
		{
			title: 'Faqs Section',
			modules: [
				{
					type: 'faqs',
					props: {
						header: 'Wine Storage FAQs',
						faqs,
					},
				},
			],
		},
		{
			title: 'featured content',
			background: 'gray',
			modules: [
				{
					type: 'featuredContent',
					props: {
						slug: 'wine-featured-content',
						contentCards: [
							{
								title: 'Self Storage',
								date: 'September 5, 2025',
								image: wineFeatured1,
								content:
									'How Much Does Wine Storage Cost in 2025? Solutions and Pricing for Storing Wine ' +
									'Collections of Any Size',
								link: 'https://www.sparefoot.com/blog/wine-storage-pricing-guide-2025',
							},
							{
								title: 'How to Store It',
								date: 'October 24, 2025',
								image: wineFeatured2,
								content:
									'How to Store Wine Correctly: 5 Recommendations for Primo Vino',
								link:
									'https://www.sparefoot.com/blog/wine-storing-tips-for-the-wine-newbie-ports-caber' +
									'nets-and-muscatos-oh-my-2',
							},
							{
								title: 'Moving Tips',
								date: 'September 5, 2025',
								image: wineFeatured3,
								content:
									'How to Move Your Wine Collection to Your New Home',
								link: 'https://www.sparefoot.com/blog/how-to-move-wine',
							},
						],
					},
				},
			],
		},
		{
			title: 'Link to other PSPs',
			modules: [
				{
					type: 'links',
					props: {
						title: 'More Ways to Store',
						cards: [
							'ClimateControl',
							'24Hour',
							'Electricity',
							'Business',
							'Portable',
							'DriveUp',
							'Car',
							'RV',
						],
					},
				},
			],
		},
		{
			title: 'nearby units',
			// background: 'gray',
			modules: [
				{
					type: 'storageNearYou',
				},
			],
		},
	],
};
